import { type IDropdownItem } from 'shared/ui'
import { ChatbotActionType, type IChatbotActionType } from 'entities/Chatbot'
import { ActionMessage } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions/ActionMessage'
import { ActionNote } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions/ActionNote'
import { makeActionTags } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions/ActionTags'
import type { ActionConfig } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions/type'

export const ACTION_ITEMS: IDropdownItem[] = [
  {
    id: ChatbotActionType.AddTag,
    label: 'Add tag',
    iconL: 'tag',
  },
  {
    id: ChatbotActionType.RemoveTag,
    label: 'Remove tag',
    iconL: 'tagRemove',
  },
  {
    id: ChatbotActionType.SendMessage,
    label: 'Send message',
    iconL: 'messageTextCircle02',
  },
  {
    id: ChatbotActionType.ContactNote,
    label: 'Add contact note',
    iconL: 'edit',
  },
]

export const ACTIONS_CONFIG = {
  [ChatbotActionType.AddTag]: {
    icon: 'tag',
    title: 'Add tag',
    Component: makeActionTags({
      canCreate: true,
      placeholder: 'Search or create',
    }),
  },
  [ChatbotActionType.RemoveTag]: {
    icon: 'tagRemove',
    title: 'Remove tag',
    Component: makeActionTags({
      canCreate: false,
      placeholder: 'Search',
    }),
  },
  [ChatbotActionType.ContactNote]: {
    icon: 'edit',
    title: 'Contact note',
    Component: ActionNote,
  },
  [ChatbotActionType.SendMessage]: {
    icon: 'messageTextCircle02',
    title: 'Send message',
    Component: ActionMessage,
  },
} as Record<IChatbotActionType, ActionConfig>
